/* Settlement Report Studio - core logic (no UI, no network).
 * Schema I/O, recalculation rules from the Excel template, layout model, Excel and PDF builders.
 */

/* ------------------------------------------------------------------ schema */
var REPORT_COLUMNS = ['settlement_report_id', 'report_year', 'as_at_date', 'legal_entity', 'client_name',
  'project_code', 'account_manager', 'company_name', 'address_line_1', 'address_line_2', 'address_line_3',
  'address_line_4', 'address_line_5', 'contact_email', 'vat_number', 'contract_basis', 'power_contract',
  'om_terms', 'software_licence_terms', 'payment_terms', 'reactive_maintenance_terms', 'extra_fields',
  'approved', 'source_folder', 'source_file'];
var FIGURE_COLUMNS = ['settlement_report_id', 'report_year', 'as_at_date', 'section', 'site_name', 'line_item',
  'line_item_code', 'period_type', 'period_label', 'period_start', 'value', 'value_text', 'source_page'];
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var NCOL = 17; // 12 months + 4 quarters + year

function pad(n) { return (n < 10 ? '0' : '') + n; }
function periodMeta(idx, year) {
  if (idx < 12) return { type: 'month', label: MONTHS[idx], start: year + '-' + pad(idx + 1) + '-01' };
  if (idx < 16) { var q = idx - 12; return { type: 'quarter', label: 'Q' + (q + 1), start: year + '-' + pad(3 * q + 1) + '-01' }; }
  return { type: 'year', label: String(year), start: year + '-01-01' };
}
function periodIdx(type, label) {
  if (type === 'month') return MONTHS.indexOf(label);
  if (type === 'quarter') return 12 + Number(String(label).slice(1)) - 1;
  return 16;
}
function headLabels(year) { return MONTHS.concat(['Q1', 'Q2', 'Q3', 'Q4', String(year)]); }

/* --------------------------------------------------------------------- CSV */
function parseCSV(text) {
  if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
  var rows = [], row = [], field = '', q = false, i, c;
  for (i = 0; i < text.length; i++) {
    c = text[i];
    if (q) {
      if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else q = false; } else field += c;
    } else if (c === '"') q = true;
    else if (c === ',') { row.push(field); field = ''; }
    else if (c === '\n' || c === '\r') {
      if (c === '\r' && text[i + 1] === '\n') i++;
      row.push(field); field = '';
      if (row.length > 1 || row[0] !== '') rows.push(row);
      row = [];
    } else field += c;
  }
  if (field !== '' || row.length) { row.push(field); rows.push(row); }
  var head = rows.shift() || [];
  return rows.map(function (r) {
    var o = {};
    head.forEach(function (h, k) { o[h] = r[k] === undefined ? '' : r[k]; });
    return o;
  });
}
function csvCell(v) {
  if (v === null || v === undefined) return '';
  if (typeof v === 'boolean') return v ? 'true' : 'false';
  var s = String(v);
  return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}
function toCSV(rows, cols) {
  var out = [cols.join(',')];
  rows.forEach(function (r) { out.push(cols.map(function (c) { return csvCell(r[c]); }).join(',')); });
  return out.join('\n') + '\n';
}

/* ------------------------------------------------------------------- model */
function keyOf(r) { return r.settlement_report_id + '|' + r.report_year + '|' + r.as_at_date; }
function normReport(r) {
  var o = {};
  REPORT_COLUMNS.forEach(function (c) { var v = r[c]; o[c] = (v === undefined || v === '') ? null : v; });
  o.report_year = Number(o.report_year);
  o.approved = String(r.approved).toLowerCase() === 'true' || r.approved === 't';
  var ex = {};
  try { ex = o.extra_fields ? JSON.parse(o.extra_fields) : {}; } catch (e) { ex = {}; }
  o.extra = ex && typeof ex === 'object' && !Array.isArray(ex) ? ex : {};
  delete o.extra_fields;
  return o;
}
function normFigure(r) {
  return {
    section: r.section, site_name: r.site_name || null, line_item: r.line_item,
    line_item_code: r.line_item_code, period_type: r.period_type, period_label: r.period_label,
    period_start: r.period_start, value: r.value === '' || r.value === undefined ? null : Number(r.value),
    vstr: r.value === undefined ? '' : r.value,          // original text of the number, kept so untouched cells re-export identically
    value_text: r.value_text, source_page: r.source_page ? Number(r.source_page) : null
  };
}
function clone(o) { return JSON.parse(JSON.stringify(o)); }

function loadModels(reportRows, figureRows) {
  var models = [], byKey = {};
  reportRows.forEach(function (r) {
    var rep = normReport(r), k = keyOf(rep);
    byKey[k] = { key: k, report: rep, figures: [] };
    models.push(byKey[k]);
  });
  var orphans = 0;
  figureRows.forEach(function (r) {
    var k = r.settlement_report_id + '|' + r.report_year + '|' + r.as_at_date;
    if (byKey[k]) byKey[k].figures.push(normFigure(r)); else orphans++;
  });
  models.forEach(function (m) { m.origReport = clone(m.report); m.origFigures = clone(m.figures); });
  return { models: models, orphans: orphans };
}
function exportValue(f) {
  if (f.value === null || f.value === undefined) return null;
  if (f.vstr !== undefined && f.vstr !== '' && Number(f.vstr) === f.value) return f.vstr;
  var k = kindOf(f.line_item_code);
  return k === 'money' ? f.value.toFixed(2) : k === 'pct' ? f.value.toFixed(1) : String(f.value);
}
function exportRows(models) {
  var reps = [], figs = [];
  models.forEach(function (m) {
    var r = Object.assign({}, m.report);
    r.extra_fields = Object.keys(m.report.extra || {}).length ? JSON.stringify(m.report.extra) : null;
    reps.push(r);
    m.figures.forEach(function (f) {
      figs.push(Object.assign({
        settlement_report_id: m.report.settlement_report_id, report_year: m.report.report_year,
        as_at_date: m.report.as_at_date
      }, f, { value: exportValue(f) }));
    });
  });
  return { reports: reps, figures: figs };
}

/* ------------------------------------------------------------ lines & cells */
function lineKey(f) { return f.section + '|' + (f.site_name || '') + '|' + f.line_item_code; }
function linesOf(figs) {
  var map = {}, out = [];
  figs.forEach(function (f) {
    var k = lineKey(f), L = map[k];
    if (!L) {
      L = map[k] = { id: k, section: f.section, site: f.site_name || null, code: f.line_item_code, item: f.line_item, cells: new Array(NCOL).fill(null) };
      out.push(L);
    }
    var i = periodIdx(f.period_type, f.period_label);
    if (i >= 0) L.cells[i] = f;
  });
  return out;
}
function kindOf(code) {
  if (/_pct$/.test(code)) return 'pct';
  if (/^num_/.test(code) || /kwh/.test(code)) return 'int';
  return 'money';
}
function roundKind(kind, v) {
  if (kind === 'int') return Math.round(v);
  if (kind === 'pct') return Math.round(v * 10) / 10;
  return Math.round((v + (v < 0 ? -Number.EPSILON : Number.EPSILON)) * 100) / 100;
}
function fmtNum(kind, v) {
  var neg = v < 0, a = Math.abs(v), s;
  if (kind === 'int') s = String(Math.round(a));
  else if (kind === 'pct') s = a.toFixed(1);
  else s = (Math.round((a + Number.EPSILON) * 100) / 100).toFixed(2);
  var parts = s.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  s = parts.join('.') + (kind === 'pct' ? '%' : '');
  return (neg ? '-' : '') + s;
}
/* The report shows negative values the accounting way: (1,234.50) instead of -1,234.50. (fmtNum, with the minus sign, is still what is stored.) */
function fmtReport(kind, v) {
  var s = fmtNum(kind, v);
  return s.charAt(0) === '-' && /[1-9]/.test(s) ? '(' + s.slice(1) + ')' : s.replace(/^-/, '');
}
/* '' or '-' -> empty cell ; '1,234.5' / '£12' / '(3.20)' / '85%' -> number ; anything else -> null (invalid) */
function parseCellText(txt) {
  var t = String(txt).trim();
  if (t === '' || t === '-') return { value: null };
  var neg = /^\(.*\)$/.test(t);
  t = t.replace(/^\(|\)$/g, '').replace(/[£,%\s]/g, '');
  if (!/^-?\d*\.?\d+$/.test(t) && !/^-?\d+\.?$/.test(t)) return null;
  var n = Number(t);
  if (!isFinite(n)) return null;
  return { value: neg ? -Math.abs(n) : n };
}

/* ------------------------------------------------- recalculation (template rules) */
// Verified against the workbook formulas:
//   Total Revenue (exc VAT)  = Power Sales (inc VAT) / 1.2
//   Cost of Sales            = Power Costs + Standing Charges + Transaction Fees
//   Support Services Cost    = Operations & Scheduled Maintenance + Software Licence Fees
//   Operating Profit         = Revenue - Cost of Sales - Support Services Cost
//   Customer Share (£)       = Operating Profit x Customer Share (%)
//   Profit for Distribution  = Customer Share (£)
//   Quarters / year          = sums of the months (a quarter that starts after the "as at" date is "-")
var DERIVED_ORDER = ['total_revenue_exc_vat', 'cost_of_sales', 'support_services_cost', 'operating_profit_exc_vat',
  'customer_share_gbp', 'profit_for_distribution_exc_vat'];
var DERIVED_DEPS = {
  total_revenue_exc_vat: ['power_sales_inc_vat'],
  cost_of_sales: ['power_costs', 'standing_charges', 'transaction_fees_card_payments'],
  support_services_cost: ['operations_and_scheduled_maintenance_charges', 'software_licence_fees'],
  operating_profit_exc_vat: ['total_revenue_exc_vat', 'client_share_exc_vat', 'cost_of_sales', 'support_services_cost'],
  customer_share_gbp: ['operating_profit_exc_vat', 'customer_share_pct'],
  profit_for_distribution_exc_vat: ['customer_share_gbp']
};
var ZERO_DASH = {
  power_costs: 1, standing_charges: 1, transaction_fees_card_payments: 1, cost_of_sales: 1,
  operations_and_scheduled_maintenance_charges: 1, software_licence_fees: 1, support_services_cost: 1,
  annual_concession_fee_cpi_inc: 1, operating_profit_exc_vat: 1, customer_share_gbp: 1, profit_for_distribution_exc_vat: 1
};

function ctxFor(figs, report) {
  var copy = figs.map(function (f) { return Object.assign({}, f); });
  var lines = linesOf(copy), byKey = {};
  lines.forEach(function (l) { byKey[l.id] = l; });
  return { report: report, copy: copy, lines: lines, byKey: byKey };
}
function monthActive(ctx, m) { return periodMeta(m, ctx.report.report_year).start <= ctx.report.as_at_date; }
function quarterActive(ctx, q) { return monthActive(ctx, 3 * q); }
function isAdditive(L) { return L.section === 'by_site' || (L.section === 'financials' && L.code !== 'customer_share_pct'); }

function setCell(ctx, L, idx, value, zeroDash) {
  var kind = kindOf(L.code);
  if (value !== null && zeroDash && value === 0 && ZERO_DASH[L.code]) value = null;
  if (value !== null) value = roundKind(kind, value);
  if (value !== null && zeroDash && value === 0 && ZERO_DASH[L.code]) value = null;
  var c = L.cells[idx];
  if (!c) {
    var pm = periodMeta(idx, ctx.report.report_year);
    c = { section: L.section, site_name: L.site, line_item: L.item, line_item_code: L.code, period_type: pm.type,
      period_label: pm.label, period_start: pm.start, value: null, value_text: '-', source_page: null };
    L.cells[idx] = c; ctx.copy.push(c);
  }
  c.value = value;
  delete c.vstr;
  c.value_text = value === null ? '-' : fmtNum(kind, value);
}
function getVal(ctx, code, m) {
  var L = ctx.byKey['financials||' + code], c = L && L.cells[m];
  return c && c.value !== null ? c.value : null;
}
function num(v) { return v === null || v === undefined ? 0 : v; }
function computeDerived(ctx, code, m) {
  var g = function (c) { return getVal(ctx, c, m); };
  switch (code) {
    case 'total_revenue_exc_vat': { var p = g('power_sales_inc_vat'); return p === null ? null : p / 1.2; }
    case 'cost_of_sales': return num(g('power_costs')) + num(g('standing_charges')) + num(g('transaction_fees_card_payments'));
    case 'support_services_cost': return num(g('operations_and_scheduled_maintenance_charges')) + num(g('software_licence_fees'));
    case 'operating_profit_exc_vat': {
      var rev = g('total_revenue_exc_vat'); if (rev === null) rev = g('client_share_exc_vat');
      return num(rev) - num(g('cost_of_sales')) - num(g('support_services_cost'));
    }
    case 'customer_share_gbp': {
      var op = g('operating_profit_exc_vat'), pct = g('customer_share_pct');
      return op === null ? null : op * (pct === null ? 1 : pct / 100);
    }
    case 'profit_for_distribution_exc_vat': return g('customer_share_gbp');
    default: break;
  }
  return null;
}
function sumRange(L, from, to) {
  var any = false, sum = 0;
  for (var m = from; m < to; m++) { var c = L.cells[m]; if (c && c.value !== null) { any = true; sum += c.value; } }
  return any ? sum : null;
}
function rollupLine(ctx, L, q) {
  if (!isAdditive(L)) return;
  var qs = q === null || q === undefined ? [0, 1, 2, 3] : [q];
  qs.forEach(function (k) {
    var s = quarterActive(ctx, k) ? sumRange(L, 3 * k, 3 * k + 3) : null;
    setCell(ctx, L, 12 + k, s, true);
  });
  setCell(ctx, L, 16, sumRange(L, 0, 12), true);
}
function propagate(ctx, L, m) {
  if (m >= 12) return;
  var q = Math.floor(m / 3);
  if (L.section === 'by_site') { rollupLine(ctx, L, q); return; }
  if (L.section !== 'financials') return;
  var dirty = {}; dirty[L.code] = true;
  DERIVED_ORDER.forEach(function (code) {
    var D = ctx.byKey['financials||' + code];
    if (!D || !DERIVED_DEPS[code].some(function (d) { return dirty[d]; })) return;
    dirty[code] = true;
    setCell(ctx, D, m, monthActive(ctx, m) ? computeDerived(ctx, code, m) : null, true);
  });
  Object.keys(dirty).forEach(function (code) {
    var D = ctx.byKey['financials||' + code];
    if (D) rollupLine(ctx, D, q);
  });
}
/* A user edit. `sync` keeps derived lines and totals up to date. Returns the new figure array. */
function editCell(figs, report, lineId, idx, value, sync) {
  var ctx = ctxFor(figs, report), L = ctx.byKey[lineId];
  if (!L) return figs;
  setCell(ctx, L, idx, value, false);
  if (sync) propagate(ctx, L, idx);
  return ctx.copy;
}
/* Counts (chargepoints, sites, sockets) are not added up: a quarter / the year shows the latest month's count that has a value. */
function isCount(L) { return L.section === 'site_detail' && /^num_/.test(L.code); }
function latestRange(L, from, to) {
  for (var m = to - 1; m >= from; m--) { var c = L.cells[m]; if (c && c.value !== null) return c.value; }
  return null;
}
function rollupCount(ctx, L) {
  for (var k = 0; k < 4; k++) setCell(ctx, L, 12 + k, quarterActive(ctx, k) ? latestRange(L, 3 * k, 3 * k + 3) : null, false);
  setCell(ctx, L, 16, latestRange(L, 0, 12), false);
}
/* Quarters and the year are never stored: they are calculated from the months every time a report is loaded. Any quarter / year
 * rows that are still in the data are ignored. Sums for money, kWh and the per-site lines; the latest month for counts; the
 * customer share % has months only. */
function calculateTotals(figs, report) {
  var months = figs.filter(function (f) { return f.period_type === 'month'; });
  var ctx = ctxFor(months, report);
  fillCustomerShare(ctx);
  ctx.lines.slice().forEach(function (L) { if (isCount(L)) rollupCount(ctx, L); else rollupLine(ctx, L, null); });
  return ctx.copy;
}
/* The monthly Customer Share (£) is Operating Profit x Customer Share (%). When a month has no stored £ figure (the source table may only
 * hold the % and the operating profit), calculate it so that the quarters and the year, which add up the months, are not blank.
 * A stored monthly figure is never overwritten. */
function fillCustomerShare(ctx) {
  var op = ctx.byKey['financials||operating_profit_exc_vat'], pct = ctx.byKey['financials||customer_share_pct'];
  if (!op || !pct) return;
  var L = ctx.byKey['financials||customer_share_gbp'];
  for (var m = 0; m < 12; m++) {
    if (!monthActive(ctx, m)) continue;
    if (L && L.cells[m] && L.cells[m].value !== null && L.cells[m].value !== undefined) continue;
    var o = getVal(ctx, 'operating_profit_exc_vat', m), p = getVal(ctx, 'customer_share_pct', m);
    if (o === null || p === null) continue;
    if (!L) {
      L = { id: 'financials||customer_share_gbp', section: 'financials', site: null, code: 'customer_share_gbp', item: 'Customer Share (£)', cells: new Array(NCOL).fill(null) };
      ctx.lines.push(L); ctx.byKey[L.id] = L;
    }
    setCell(ctx, L, m, o * (p / 100), true);
  }
}
function rollupAll(figs, report) {
  var ctx = ctxFor(figs, report);
  ctx.lines.slice().forEach(function (L) { rollupLine(ctx, L, null); });
  return ctx.copy;
}

/* ------------------------------------------------------ add / remove lines */
var OPTIONAL_LINES = [
  { code: 'maintenance_service', item: 'Maintenance Service', section: 'financials' },
  { code: 'annual_concession_fee_cpi_inc', item: 'Annual concession fee (CPI inc.)', section: 'financials' }
];
function addLine(figs, report, section, site, code, item, sync) {
  var ctx = ctxFor(figs, report), id = section + '|' + (site || '') + '|' + code;
  if (ctx.byKey[id]) return figs;
  var L = { id: id, section: section, site: site || null, code: code, item: item, cells: new Array(NCOL).fill(null) };
  ctx.lines.push(L); ctx.byKey[id] = L;
  for (var i = 0; i < NCOL; i++) setCell(ctx, L, i, null, false);
  if (sync) rollupLine(ctx, L, null);
  return ctx.copy;
}
function removeLines(figs, pred) { return figs.filter(function (f) { return !pred(f); }); }
function siteBlocks(figs) {   // by_site groups in first-appearance order: [{code, item, lines:[...]}]
  var blocks = [], map = {};
  linesOf(figs).forEach(function (L) {
    if (L.section !== 'by_site') return;
    var b = map[L.code];
    if (!b) { b = map[L.code] = { code: L.code, item: L.item, lines: [] }; blocks.push(b); }
    b.lines.push(L);
  });
  return blocks;
}
function addSite(figs, report, name, sync) {
  var blocks = siteBlocks(figs);
  if (!blocks.length) {
    blocks = [{ code: 'total_power_usage_kwh_by_site', item: 'Total Power Usage (kWh) by Site' },
      { code: 'power_revenue_gbp_by_site', item: 'Power Revenue (£) by Site' }];
  }
  var out = figs;
  blocks.forEach(function (b) { out = addLine(out, report, 'by_site', name, b.code, b.item, sync); });
  return out;
}

/* -------------------------------------------------------- diff & checks */
function cellMap(figs) {
  var m = {};
  figs.forEach(function (f) { m[lineKey(f) + '|' + periodIdx(f.period_type, f.period_label)] = f; });
  return m;
}
function valueMap(figs) {   // 'lineId|idx' -> value_text, to mark edited cells
  var m = {};
  figs.forEach(function (f) { m[lineKey(f) + '|' + periodIdx(f.period_type, f.period_label)] = f.value_text; });
  return m;
}
function labelOf(L) { return L.site ? L.site + ' - ' + L.item.replace(/ by Site\s*$/, '') : L.item; }
function diffFigures(origFigs, curFigs, year) {
  var a = cellMap(origFigs), b = cellMap(curFigs), out = [], heads = headLabels(year);
  var order = {}, labels = {};
  linesOf(origFigs).concat(linesOf(curFigs)).forEach(function (L) { if (!(L.id in order)) { order[L.id] = Object.keys(order).length; labels[L.id] = labelOf(L); } });
  var keys = {};
  Object.keys(a).concat(Object.keys(b)).forEach(function (k) { keys[k] = 1; });
  Object.keys(keys).forEach(function (k) {
    var i = k.lastIndexOf('|'), lid = k.slice(0, i), idx = Number(k.slice(i + 1));
    var x = a[k], y = b[k];
    var from = x ? x.value_text : null, to = y ? y.value_text : null;
    if (from === to) return;
    out.push({ lineId: lid, ord: order[lid], idx: idx, label: labels[lid], period: heads[idx], from: from, to: to });
  });
  out.sort(function (p, q) { return p.ord - q.ord || p.idx - q.idx; });
  return out;
}
function checkKwh(figs) {  // financial kWh vs the sum of the per-site kWh, per month
  var fin = linesOf(figs).filter(function (L) { return L.section === 'financials' && L.code === 'total_power_usage_kwh'; })[0];
  var sites = linesOf(figs).filter(function (L) { return L.section === 'by_site' && /kwh/.test(L.code); });
  if (!fin || !sites.length) return [];
  var out = [];
  for (var m = 0; m < 12; m++) {
    var s = 0, any = false;
    for (var k = 0; k < sites.length; k++) {
      var c = sites[k].cells[m];
      if (c && c.value !== null) { s += c.value; any = true; }
    }
    var f = fin.cells[m] && fin.cells[m].value;
    if (any && f !== null && f !== undefined && Math.abs(s - f) > 0.5) out.push({ month: MONTHS[m], financials: f, sites: s });
  }
  return out;
}

/* ------------------------------------------------------------------ layout */
var SD_ORDER = ['num_sites', 'num_chargepoints_public', 'num_chargepoints_public_single', 'num_chargepoints_public_dual',
  'num_chargepoints_private', 'num_chargepoints_private_single', 'num_chargepoints_private_dual', 'num_sockets'];
var FIN_ORDER = ['total_power_usage_kwh', 'power_sales_inc_vat', 'total_revenue_exc_vat', 'client_share_exc_vat', 'power_costs',
  'standing_charges', 'transaction_fees_card_payments', 'cost_of_sales', 'operations_and_scheduled_maintenance_charges',
  'software_licence_fees', 'maintenance_service', 'support_services_cost', 'operating_profit_exc_vat', 'customer_share_pct',
  'customer_share_gbp', 'annual_concession_fee_cpi_inc', 'profit_for_distribution_exc_vat'];
var BLANK_BEFORE = { num_chargepoints_public: 1, num_chargepoints_private: 1, num_sockets: 1, power_sales_inc_vat: 1, power_costs: 1,
  operations_and_scheduled_maintenance_charges: 1, operating_profit_exc_vat: 1, customer_share_pct: 1 };
/* How the Financials lines are drawn on the report: bold (label and values), a thin line above the row, a grey band across the whole row.
 * Everything else on that page is plain. */
var FIN_STYLE = {
  total_power_usage_kwh: { bold: true },
  total_revenue_exc_vat: { bold: true, line: true },         // line between Power Sales and Total Revenue
  client_share_exc_vat: { bold: true, line: true },          // (the same line when the report says Client Share instead)
  cost_of_sales: { bold: true, line: true },                 // line between Transaction Fees and Cost of Sales
  support_services_cost: { bold: true, line: true },         // line between Software Licence Fees (or Maintenance Service) and Support Services Cost
  operating_profit_exc_vat: { bold: true, shade: true },
  profit_for_distribution_exc_vat: { shade: true }
};
var SUB_LINE = { num_chargepoints_public_single: 1, num_chargepoints_public_dual: 1, num_chargepoints_private_single: 1, num_chargepoints_private_dual: 1 };
var TERMS = [['Contract Basis', 'contract_basis'], ['Power Contract', 'power_contract'], ['O&M', 'om_terms'],
  ['Software Licence', 'software_licence_terms'], ['Payment Terms', 'payment_terms'], ['Reactive Maintenance', 'reactive_maintenance_terms']];

function sortLines(lines, order) {
  return lines.map(function (L, i) { var r = order.indexOf(L.code); return { L: L, r: r < 0 ? 1000 + i : r }; })
    .sort(function (a, b) { return a.r - b.r; }).map(function (x) { return x.L; });
}
function dmy(iso) { var p = String(iso || '').split('-'); return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : String(iso || ''); }
function gridRow(L, opts) {
  var kind = kindOf(L.code);
  var cells = L.cells.map(function (c) {
    if (!c) return { v: null, t: '' };
    return { v: c.value, t: c.value !== null ? fmtReport(kind, c.value) : c.value_text };
  });
  return Object.assign({ k: 'grid', id: L.id, site: L.site, label: L.site || L.item, code: L.code, section: L.section, kind: kindOf(L.code), cells: cells,
    bold: true, center: false, line: false, shade: false }, opts || {});
}
function buildLayout(report, figs) {
  var r = report, lines = linesOf(figs), rows1 = [], rows2 = [], pages = [];
  var sd = sortLines(lines.filter(function (L) { return L.section === 'site_detail'; }), SD_ORDER);
  var fin = sortLines(lines.filter(function (L) { return L.section === 'financials'; }), FIN_ORDER);
  rows1.push({ k: 'section', title: 'Site, Chargepoint & Socket Detail' });
  sd.forEach(function (L) {
    if (BLANK_BEFORE[L.code]) rows1.push({ k: 'blank' });
    rows1.push(gridRow(L, { center: true, bold: !SUB_LINE[L.code] }));
  });
  rows1.push({ k: 'blank' });
  rows1.push({ k: 'section', title: 'Commercial Terms' });
  TERMS.forEach(function (t) { rows1.push({ k: 'kv', label: t[0], value: r[t[1]] || '' }); });
  Object.keys(r.extra || {}).forEach(function (k) { rows1.push({ k: 'kv', label: k, value: String(r.extra[k]) }); });
  pages.push({ name: 'detail', rows: rows1 });

  rows2.push({ k: 'section', title: 'Financials (£)' });
  fin.forEach(function (L) {
    if (BLANK_BEFORE[L.code]) rows2.push({ k: 'blank' });
    rows2.push(gridRow(L, Object.assign({ bold: false, line: false, shade: false }, FIN_STYLE[L.code])));
  });
  if (fin.length) pages.push({ name: 'financials', rows: rows2 });

  siteBlocks(figs).forEach(function (b, i) {
    var rows = [];
    if (i === 0) rows.push({ k: 'section', title: 'Sites Breakdown' });
    rows.push({ k: 'sub', title: b.item.replace(/\s+$/, '') });
    b.lines.forEach(function (L) { rows.push(gridRow(L, { bold: false })); });
    pages.push({ name: 'sites', rows: rows });
  });

  var hl = [
    { k: 'kv', label: 'Contract', value: r.legal_entity }, { k: 'kv', label: 'Settlement Report', value: r.client_name },
    { k: 'id', value: r.settlement_report_id }, { k: 'kv', label: 'Project ID', value: r.project_code }, { k: 'gap' },
    { k: 'kv', label: 'Account Manager', value: r.account_manager }, { k: 'gap' },
    { k: 'kv', label: 'Connected Kerb', value: r.company_name },
    { k: 'kv', label: 'Third Floor Cargo Works', value: r.address_line_1 }, { k: 'kv', label: ' 1-2 Hatfields', value: r.address_line_2 },
    { k: 'kv', label: 'London', value: r.address_line_3 }, { k: 'kv', label: 'England', value: r.address_line_4 },
    { k: 'kv', label: 'SE1 9PG', value: r.address_line_5 }
  ];
  if (r.contact_email) hl.push({ k: 'text', value: r.contact_email });
  if (r.vat_number) hl.push({ k: 'text', value: 'VAT: ' + r.vat_number });
  return { report: r, year: r.report_year, asAt: dmy(r.as_at_date), heads: headLabels(r.report_year), headerLines: hl, pages: pages };
}

/* ---------------------------------------------------------------- Excel */
function colOf(i) { return i < 12 ? 3 + i : i < 16 ? 16 + (i - 12) : 21; }
/* Where to put a logo of `imgW` pixels so that it ends at the right-hand edge of a sheet whose columns are `widths` characters wide:
 * the (fractional, 0-based) column its left edge falls in. */
function logoCol(widths, imgW) {
  var need = imgW + 8, acc = 0, c;
  for (c = widths.length - 1; c >= 0; c--) {
    var px = Math.round(widths[c] * 7 + 5);
    if (acc + px >= need) return c + (acc + px - need) / px;
    acc += px;
  }
  return 0;
}
/* The logo as a picture in a worksheet, at the top right: `h` pixels high, `top` pixels down from the top of row `row` (0-based). */
function placeLogo(wb, ws, logo, widths, row, top, h, rowPx) {
  if (!logo) return;
  var w = Math.round(h * logo.w / logo.h);
  var id = wb.addImage({ base64: logo.base64, extension: 'png' });
  ws.addImage(id, { tl: { col: logoCol(widths, w), row: row + top / rowPx }, ext: { width: w, height: h }, editAs: 'oneCell' });
}

async function buildWorkbook(ExcelJS, L) {
  var wb = new ExcelJS.Workbook();
  wb.creator = 'Settlement Report Studio';
  var ws = wb.addWorksheet('GeneratedReport');
  var partial = !!L.partial, LAST = partial ? 3 + L.heads.length : 21;      // a single period / quarter has only a few columns
  var widths = [38.7, 11.4], i;
  if (partial) { for (i = 0; i < L.heads.length; i++) widths.push(14.9); widths.push(3.7); }
  else {
    for (i = 0; i < 12; i++) widths.push(11.3);
    widths.push(3.7); for (i = 0; i < 4; i++) widths.push(11.3);
    widths.push(4); widths.push(14.9);
  }
  ws.columns = widths.map(function (w) { return { width: w }; });
  var DARK = 'FF191919', LIGHT = 'FFE1E1E1', GREY = 'FFD9D9D9', FONT = 'Aptos Narrow';
  var fill = function (c) { return { type: 'pattern', pattern: 'solid', fgColor: { argb: c } }; };
  var fillRow = function (r, color) { for (var c = 1; c <= LAST; c++) ws.getCell(r, c).fill = fill(color); };
  var r = 1;
  fillRow(1, DARK); ws.getRow(1).height = 8;
  fillRow(2, DARK); ws.getRow(2).height = 40;
  ws.getCell(2, 1).value = 'Settlement Report'; ws.getCell(2, 1).font = { name: FONT, size: 28, color: { argb: LIGHT } };
  fillRow(3, DARK); ws.getRow(3).height = 22;
  ws.getCell(3, 1).value = 'As at ' + L.asAt; ws.getCell(3, 1).font = { name: FONT, size: 14, color: { argb: LIGHT } };
  fillRow(4, DARK); ws.getRow(4).height = 8;
  placeLogo(wb, ws, L.logo, widths, 1, 0, 50, 53);          // top right of the black band (rows 2-3)
  r = 6;
  L.headerLines.forEach(function (h) {
    if (h.k === 'kv') {
      ws.getCell(r, 1).value = h.label; ws.getCell(r, 1).font = { name: FONT, size: 11, bold: true };
      if (h.value) { ws.getCell(r, 2).value = h.value; ws.getCell(r, 2).font = { name: FONT, size: 11 }; }
    } else if (h.k === 'id') { ws.getCell(r, 2).value = h.value; ws.getCell(r, 2).font = { name: FONT, size: 11 }; }
    else if (h.k === 'text') { ws.getCell(r, 1).value = h.value; ws.getCell(r, 1).font = { name: FONT, size: 11 }; }
    r++;
  });
  r++;
  var yearRow = r;
  for (var c = 1; c <= LAST; c++) {
    var a = ws.getCell(yearRow, c), b = ws.getCell(yearRow + 1, c);
    a.fill = fill(LIGHT); b.fill = fill(LIGHT);
    a.font = b.font = { name: FONT, size: 12, bold: true, color: { argb: DARK } };
    a.alignment = b.alignment = { horizontal: c >= 3 ? 'center' : 'left' };
    a.border = { top: { style: 'medium' } }; b.border = { bottom: { style: 'medium' } };
  }
  ws.getCell(yearRow, 1).value = 'Year'; ws.getCell(yearRow, 3).value = L.year;
  if (partial) {
    ws.getCell(yearRow + 1, 1).value = 'Period';
    L.heads.forEach(function (h, k) { ws.getCell(yearRow + 1, 3 + k).value = h; });
  } else {
    ws.getCell(yearRow + 1, 1).value = 'Month';
    for (i = 0; i < 12; i++) { var d = ws.getCell(yearRow + 1, 3 + i); d.value = new Date(Date.UTC(L.year, i, 1)); d.numFmt = 'mmm'; }
    ['Q1', 'Q2', 'Q3', 'Q4'].forEach(function (q, k) { ws.getCell(yearRow + 1, 16 + k).value = q; });
    ws.getCell(yearRow + 1, 21).value = L.year; ws.getCell(yearRow + 1, 21).numFmt = '0';
  }
  r = yearRow + 3;
  L.pages.forEach(function (pg, pi) {
    if (pi > 0) ws.getRow(r - 1).addPageBreak();
    pg.rows.forEach(function (row) {
      if (row.k === 'blank') { r++; return; }
      if (row.k === 'section' || row.k === 'sub') {
        var dark = row.k === 'section';
        for (var cc = 1; cc <= LAST; cc++) {
          var cell = ws.getCell(r, cc);
          if (dark) { cell.fill = fill(DARK); cell.border = { top: { style: 'medium' } }; }
        }
        var t = ws.getCell(r, 1); t.value = row.title;
        t.font = { name: FONT, size: 12, bold: true, color: { argb: dark ? 'FFFFFFFF' : DARK } };
        r++; return;
      }
      if (row.k === 'kv') {
        ws.getCell(r, 1).value = row.label; ws.getCell(r, 1).font = { name: FONT, size: 12, bold: true };
        if (row.value) { ws.getCell(r, 2).value = row.value; ws.getCell(r, 2).font = { name: FONT, size: 11 }; }
        r++; return;
      }
      if (row.shade || row.line) {                                  // grey band across the whole row / thin line above it
        for (var sc = 1; sc <= LAST; sc++) {
          if (row.shade) ws.getCell(r, sc).fill = fill(GREY);
          if (row.line) ws.getCell(r, sc).border = { top: { style: 'thin', color: { argb: DARK } } };
        }
      }
      var lab = ws.getCell(r, 1); lab.value = row.label;
      lab.font = { name: FONT, size: row.bold ? 12 : 11, bold: !!row.bold };
      lab.alignment = { shrinkToFit: true };      // never clip a long label, even if the font isn't installed
      row.cells.forEach(function (cell, idx) {
        if (cell.t === '' && cell.v === null) return;
        var x = ws.getCell(r, partial ? 3 + idx : colOf(idx));
        x.font = { name: FONT, size: row.center ? 12 : 11, bold: !!(row.center || row.bold) };
        x.alignment = { horizontal: row.center ? 'center' : 'right' };
        if (cell.v !== null) {
          if (row.kind === 'pct') { x.value = cell.v / 100; x.numFmt = '0.0%_);(0.0%)'; }
          else { x.value = cell.v; x.numFmt = row.kind === 'int' ? '#,##0_);(#,##0)' : '#,##0.00_);(#,##0.00)'; }
        } else x.value = cell.t;
      });
      r++;
    });
  });
  ws.pageSetup = {
    orientation: 'landscape', paperSize: 9, fitToPage: true, fitToWidth: 1, fitToHeight: 0,
    printTitlesRow: yearRow + ':' + (yearRow + 1), printArea: 'A1:' + ws.getColumn(LAST).letter + (r + 1),
    margins: { left: 0.4, right: 0.4, top: 0.5, bottom: 0.6, header: 0.3, footer: 0.3 }
  };
  ws.headerFooter.oddFooter = '&LInternal Only&RPage &P of &N';
  return wb.xlsx.writeBuffer();
}

/* ------------------------------------------------------------------ PDF */
function buildPdf(jsPDF, L) {
  var doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  var W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight();
  var M = 18, SP = 4, YW = 46, i;
  var need = 0;
  doc.setFontSize(7);
  L.pages.forEach(function (pg) {
    pg.rows.forEach(function (r) {
      if (r.k !== 'grid') return;
      doc.setFont('helvetica', r.bold ? 'bold' : 'normal');
      need = Math.max(need, doc.getTextWidth(String(r.label)));
    });
  });
  var LW = Math.min(200, Math.max(158, Math.ceil(need) + 8));            // label column (A + B)
  var A = Math.max(118, Math.ceil(0.6 * (LW - 1)) + 10), B = LW - A;      // A = where the header values start
  var MW = Math.min(37, (W - 2 * M - LW - 2 * SP - YW) / 16);
  var cs = { 0: { cellWidth: A }, 1: { cellWidth: B } };
  var partial = !!L.partial, NH = L.heads.length, NC, dark = [25, 25, 25];
  if (partial) {                                                    // one period / one quarter: a few wide columns, no spacers
    for (i = 2; i < 2 + NH; i++) cs[i] = { cellWidth: 72, halign: 'right' };
    NC = 2 + NH;
  } else {
    for (i = 2; i <= 13; i++) cs[i] = { cellWidth: MW, halign: 'right' };
    cs[14] = { cellWidth: SP };
    for (i = 15; i <= 18; i++) cs[i] = { cellWidth: MW, halign: 'right' };
    cs[19] = { cellWidth: SP }; cs[20] = { cellWidth: YW, halign: 'right' };
    NC = 21;
  }

  /* page 1 header block */
  doc.setFillColor(25, 25, 25); doc.rect(0, 0, W, 46, 'F');
  doc.setTextColor(225, 225, 225); doc.setFont('helvetica', 'normal'); doc.setFontSize(17);
  doc.text('Settlement Report', M + 6, 25); doc.setFontSize(9.5); doc.text('As at ' + L.asAt, M + 6, 39);
  if (L.logo) {                                                    // top right of the black band
    var lh = 32, lw = lh * L.logo.w / L.logo.h;
    doc.addImage(L.logo.dataUrl, 'PNG', W - M - lw, (46 - lh) / 2, lw, lh);
  }
  doc.setTextColor(25, 25, 25);
  var y = 62; doc.setFontSize(8);
  L.headerLines.forEach(function (h) {
    if (h.k === 'gap') { y += 5; return; }
    if (h.k === 'kv') {
      doc.setFont('helvetica', 'bold'); doc.text(h.label, M, y);
      if (h.value) { doc.setFont('helvetica', 'normal'); doc.text(String(h.value), M + A, y); }
    } else if (h.k === 'id') { doc.setFont('helvetica', 'normal'); doc.text(String(h.value), M + A, y); }
    else { doc.setFont('helvetica', 'normal'); doc.text(String(h.value), M, y); }
    y += 10;
  });
  y += 6;

  var head = function () {
    if (partial) {
      return [[{ content: 'Year', colSpan: 2, styles: { halign: 'left' } }, { content: String(L.year), colSpan: NH, styles: { halign: 'center' } }],
        [{ content: 'Period', colSpan: 2, styles: { halign: 'left' } }].concat(L.heads.map(function (h) { return { content: h, styles: { halign: 'center' } }; }))];
    }
    var r1 = [{ content: 'Year', colSpan: 2, styles: { halign: 'left' } }, { content: String(L.year), styles: { halign: 'center' } },
      { content: '', colSpan: NC - 3 }];
    var r2 = [{ content: 'Month', colSpan: 2, styles: { halign: 'left' } }];
    for (var k = 0; k < 17; k++) {
      if (k === 12 || k === 16) r2.push({ content: '' });   // spacer columns
      r2.push({ content: L.heads[k], styles: { halign: 'center' } });
    }
    return [r1, r2];
  };
  var bodyFor = function (rows) {
    return rows.map(function (row) {
      if (row.k === 'blank') return [{ content: '', colSpan: NC, styles: { minCellHeight: 4, cellPadding: 0, fontSize: 2 } }];
      if (row.k === 'section') return [{ content: row.title, colSpan: NC, styles: { fillColor: dark, textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8 } }];
      if (row.k === 'sub') return [{ content: row.title, colSpan: NC, styles: { fillColor: [240, 240, 240], fontStyle: 'bold' } }];
      if (row.k === 'kv') return [{ content: row.label, styles: { fontStyle: 'bold' } }, { content: row.value || '', colSpan: NC - 1, styles: { halign: 'left' } }];
      var look = {};                                                 // grey band / thin line above, for every cell of the row (spacer columns too)
      if (row.shade) look.fillColor = [217, 217, 217];
      if (row.line) { look.lineWidth = { top: 0.6, right: 0, bottom: 0, left: 0 }; look.lineColor = dark; }
      var out = [{ content: row.label, colSpan: 2, styles: Object.assign({ halign: 'left', fontStyle: row.bold ? 'bold' : 'normal', overflow: 'ellipsize' }, look) }];
      row.cells.forEach(function (c, k) {
        if (!partial && (k === 12 || k === 16)) out.push({ content: '', styles: Object.assign({}, look) });
        out.push({ content: c.t, styles: Object.assign({ halign: row.center ? 'center' : 'right', fontStyle: row.center || row.bold ? 'bold' : 'normal' }, look) });
      });
      return out;
    });
  };
  L.pages.forEach(function (pg, pi) {
    if (pi > 0) { doc.addPage(); y = 24; }
    doc.autoTable({
      startY: y, head: head(), body: bodyFor(pg.rows), theme: 'plain', showHead: 'everyPage', tableWidth: 'wrap',
      styles: { font: 'helvetica', fontSize: 7, cellPadding: { top: 1.6, bottom: 1.6, left: 2, right: 2 }, valign: 'middle', overflow: 'linebreak', textColor: [25, 25, 25] },
      headStyles: { fillColor: [225, 225, 225], textColor: dark, fontStyle: 'bold', fontSize: 7.5, valign: 'middle' },
      columnStyles: cs, margin: { left: M, right: M, top: 24, bottom: 28 }
    });
  });
  var n = doc.getNumberOfPages();
  for (i = 1; i <= n; i++) {
    doc.setPage(i); doc.setFont('helvetica', 'normal'); doc.setFontSize(7); doc.setTextColor(110, 110, 110);
    doc.text('Internal Only', M, H - 12); doc.text('Page ' + i + ' of ' + n, W - M, H - 12, { align: 'right' });
  }
  return doc.output('arraybuffer');
}


const SRS = {
  REPORT_COLUMNS: REPORT_COLUMNS, FIGURE_COLUMNS: FIGURE_COLUMNS, MONTHS: MONTHS, NCOL: NCOL, OPTIONAL_LINES: OPTIONAL_LINES,
  parseCSV: parseCSV, toCSV: toCSV, loadModels: loadModels, exportRows: exportRows, keyOf: keyOf, linesOf: linesOf,
  kindOf: kindOf, fmtNum: fmtNum, fmtReport: fmtReport, parseCellText: parseCellText, headLabels: headLabels, periodMeta: periodMeta,
  editCell: editCell, rollupAll: rollupAll, addLine: addLine, addSite: addSite, removeLines: removeLines, siteBlocks: siteBlocks,
  diffFigures: diffFigures, valueMap: valueMap, calculateTotals: calculateTotals, checkKwh: checkKwh, labelOf: labelOf, isAdditive: isAdditive,
  buildLayout: buildLayout, buildWorkbook: buildWorkbook, buildPdf: buildPdf, placeLogo: placeLogo, clone: clone, dmy: dmy,
  DERIVED_ORDER: DERIVED_ORDER, lineKey: lineKey
};

export default SRS;
